import { useCallback, useEffect, useState } from "react";
import AlmacenesService from "../../../services/almacenes.service";
import Utils from "../../../utils/Utils";
import { normalizarCodigoAlmacen } from "../utils/formatters";

// DECISION: una única petición compartida por todos los consumidores de la
// pantalla (cada AlmacenChip de un listado usa este hook). Si falla, se olvida
// para que el siguiente montaje lo reintente, y los chips muestran el código
let peticionAlmacenes = null;

const cargarAlmacenes = () => {
    if (!peticionAlmacenes) {
        peticionAlmacenes = AlmacenesService.obtenerAlmacenes(true)
            .then((data) => (Array.isArray(data) ? data : []))
            .catch((err) => {
                console.error("Error al cargar almacenes:", err);
                peticionAlmacenes = null;
                return [];
            });
    }
    return peticionAlmacenes;
};

/**
 * Hook con el catálogo de almacenes y la traducción de código a nombre ("01" -> "Nave 1")
 * @returns {{ almacenes: Array, getNombreAlmacen: (codigo: string) => string }}
 */
export const useAlmacenes = () => {
    const [almacenes, setAlmacenes] = useState([]);

    useEffect(() => {
        let vivo = true;
        cargarAlmacenes().then((data) => { if (vivo) setAlmacenes(data); });
        return () => { vivo = false; };
    }, []);

    const getNombreAlmacen = useCallback((codigo) => {
        const buscado = normalizarCodigoAlmacen(codigo);
        const almacen = almacenes.find((item) => normalizarCodigoAlmacen(item.CODIGO) === buscado);
        return almacen?.NOMBRE ? Utils.toCapitalize(almacen.NOMBRE) : String(codigo ?? "");
    }, [almacenes]);

    return { almacenes, getNombreAlmacen };
};
